import { SensitiveResult } from '@idea2app/ai-work-order-service';
import { FC } from 'react';
import { Col, Row } from 'react-bootstrap';

import { t } from '../model/Translation';

export const ProblemExtractionInfo: FC<SensitiveResult> = () => (
    <>
        <h5 className="mb-3">{t('problem_extraction_info')}</h5>
        <Row className="mb-3">
            <Col md={4}>
                {t('problem_category')}：{t('sensitive_order')}
            </Col>
            <Col md={4}>
                {t('warning_level')}：
                <span className="text-danger fw-bold">{t('red_warning')}</span>
            </Col>
        </Row>
        <Row className="mb-4">
            <Col md={6}>
                {t('trigger_keywords')}：{t('complaint')}
            </Col>
            <Col md={6}>{t('trigger_count')}：12次</Col>
        </Row>
        <Row className="mb-4">
            <Col md={6}>
                {t('trigger_keywords')}：{t('poor_attitude')}
            </Col>
            <Col md={6}>{t('trigger_count')}：3次</Col>
        </Row>
    </>
);
